// Google Analytics event tracking utilities

export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, {
      event_category: 'user_interaction',
      event_label: parameters.label || '',
      value: parameters.value || 0,
      ...parameters
    });
  }
};

// Predefined tracking functions for common actions
export const trackButtonClick = (buttonName, location = '') => {
  trackEvent('button_click', {
    event_category: 'engagement',
    event_label: buttonName,
    button_location: location
  });
};

export const trackSignUp = (method = 'email') => {
  trackEvent('sign_up', {
    method: method
  });
};

export const trackLogin = (method = 'email') => {
  trackEvent('login', {
    method: method
  });
};

export const trackPageView = (pageName) => {
  trackEvent('page_view', {
    page_title: pageName
  });
};